import type { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { unref } from 'vue'
import { getApi } from './api'

/**
 * Public API v1 tokens for an account. GPX admins, or the account's own admins — the endpoint
 * 403s for anyone else. The response carries `last_four` and never the plaintext, which exists
 * only in the create response and is not stored anywhere.
 *
 * `allow404` is load-bearing: admin's axios interceptor redirects the whole page to the
 * not-found route on any unflagged 404, so without it an environment whose engine lacks
 * these routes loses the entire account page, not just this panel.
 */
export default (accountId: Ref<number> | number) => {
  return useQuery({
    queryKey: ['account-public-api-tokens', () => unref(accountId)],
    queryFn: async () => {
      const { api, baseURL } = getApi()
      const res = await api.get(
        `/api/v2/accounts/${unref(accountId)}/public-api-tokens`,
        { baseURL, allow404: true },
      )
      return res.data
    },
    enabled: !!unref(accountId),
  })
}
